import React, { forwardRef } from 'react';
import clsx from 'clsx';

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean | string;
}

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { className, error, ...props },
  ref
) {
  const isInvalid = Boolean(error);
  return (
    <textarea
      ref={ref}
      className={clsx('input-base', isInvalid && 'input-error', className)}
      aria-invalid={isInvalid || undefined}
      {...props}
    />
  );
});

export default Textarea; 